const CourierContainer = () =>{
    return(
        <div>
            sdflkj
        </div>
    )
}
export default CourierContainer